import { ReportType } from '@/api/generatedApi';

export const REPORT_TITLES: Record<ReportType, string> = {
  [ReportType.DUPLICATION]: 'Duplication Report',
  [ReportType.SIMPLIFICATION]: 'Simplification Report',
  [ReportType.CUSTOM]: 'Custom Report',
};

export const REPORT_DESCRIPTIONS: Record<ReportType, string> = {
  [ReportType.DUPLICATION]: 'Find identical assets in your catalog',
  [ReportType.SIMPLIFICATION]: 'Find similar assets in your catalog',
  [ReportType.CUSTOM]: 'Create a custom report with specific criteria',
};
